// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_layout__qg1Fg","main":"layout_main__JrRjR"};